import * as actions from '../utils/Constants';
import Routes from '../utils/Routes';
import { apiRequest, Methods } from '../utils/Api';

export const getRoles = () => {
    return {
        type: 'GET_ROLES',
        payload: fetch(process.env.REACT_APP_API_HOST + 'api/Roles', {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        }).then(res => {
            return res.json();
        })
    }
}

export const getUsersByRole = (role, includeInactive) => {
    return dispatch => dispatch({
        type: actions.GET_USERS,
        payload: apiRequest(includeInactive ? Routes.allUsers + (role || '') : Routes.users + (role || '') , Methods.get, dispatch)
    });
};

export const toggleNewUserModal = () => {
    return {
        type: actions.TOGGLE_NEW_USER_MODAL
    }
}

export const saveNewUser = (role, credentials, firstName, lastName) => {
    return dispatch =>
        dispatch({
            type: actions.SAVE_NEW_USER,
            payload: apiRequest(
                `${Routes.user}?firstName=${encodeURIComponent(firstName)}&lastName=${encodeURIComponent(lastName)}`,
                Methods.post,
                credentials, // Body
                null, // No additional query or params
                dispatch
            )
        });
};

export const clearUsersState = () => {
    return {
        type: actions.CLEAR_USERS
    }
}

export const deleteUsers = (role, userIds) => {
    return dispatch => dispatch({
        type: actions.DELETE_USERS,
        payload: apiRequest(Routes.users + (role || ''), Methods.delete, userIds, dispatch)
    });
};